module.exports = __webpack_public_path__ + "e59f1a630bb0a8261a93bf1b74ee3f7d.jpg";